import React from 'react'
import './contact.css'
import contactIcon from "../assets/contactDark.svg"
import styledSectionBreak from '../assets/lineBreak.svg'



const Contact = () => {
  return (
    <section className='contact section__bottom' id='contact'>

        <h2 className="section__title">Contact</h2>
        <span className="section__subtitle"><img src={styledSectionBreak} className='styledLineBreak' alt="" /></span>
        <div className="contact__container">
            <p className="contact__description">
            To meet our team in person and learn more about the products or services that may be best for you, request a consultation by calling us directly at (519) 641-3000 or book online: </p>
            <a href="https://redefinemd.janeapp.com/#/staff_member/8" target='blank' className="button button--flex">
                Book an Appointment&nbsp;&nbsp;
                
            </a>
        </div>
        <div className='contact__maps__container'>
          <div className='contact__maps__title'>Redefine MD Clinic Location</div>
          <span className="contact__maps__line"><img src={styledSectionBreak} className='styledLineBreak' alt="" /></span>
          <div className='contact__maps' ><iframe width="100%" height="400" frameborder="0" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=1807%20Wonderland%20Rd%20N%20Suite%20104,%20London,%20ON%20N6G%205C2+(Redefine%20MD)&amp;t=&amp;z=15&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/">gps devices</a></iframe></div>
          <span className="contact__maps__line"><img src={styledSectionBreak} className='styledLineBreak' alt="" /></span>

        </div>
    </section>
  )
}

export default Contact
